import { injectable, postConstruct } from 'inversify'
import { IConvo } from '@/model/convo'
import { MetaService, MetaServiceImpl } from './MetaService'
import { SearchQuery } from '@/model/search/search-query'
import { IReference } from '@/model/reference'
import { IStatement } from '@/model/statement'

export interface ConvoService extends MetaService<IConvo> {
  fetchConvos(query: SearchQuery): Promise<IConvo[]>
  addConvo(convo: IConvo, tags: string[], references: IReference[], statements: IStatement[]): Promise<IConvo>
  updateConvo(id: number, convo: IConvo): Promise<IConvo>
  addStatement(convo: IConvo, statement: IStatement): Promise<IConvo>
  removeStatement(convo: IConvo, statement: IStatement): Promise<IConvo>
}

@injectable()
export class ConvoServiceImpl extends MetaServiceImpl<IConvo> implements ConvoService {
  @postConstruct()
  public initialize () {
    this.serviceName = 'convos'
  }

  public fetchConvos(query: SearchQuery): Promise<IConvo[]> {
  return this.getApiService().search<IConvo[]>('convos/search', { query: query })
  }

  public addConvo(convo: IConvo, tags: string[], references: IReference[], statements: IStatement[]): Promise<IConvo> {
  return this.getApiService().post<IConvo>('convos', { 'convo': convo, 'tags': tags, 'references': references, 'statements': statements })
  }

  public updateConvo(id: number, convo: IConvo): Promise<IConvo> {
    return this.getApiService().put<IConvo>('convos', id, { 'convo': convo })
  }

  public addStatement(convo: IConvo, statement: IStatement): Promise<IConvo> {
    return this.getApiService().post<IConvo>(`${ this.serviceName }/${ convo.id }/statements/`, { statement: statement })
  }

  public removeStatement(convo: IConvo, statement: IStatement): Promise<IConvo> {
    return this.getApiService().deleteWithParams<IConvo>(`${ this.serviceName }/${ convo.id }/statements/`, { statement: statement })
  }
}
